/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabPanel, TabView } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import Grid from "@mui/material/Grid";

// Store
import { getSubModulesByRoleId } from "../../store";

// Layouts
import CreatedActivity from "./created-activity";
import DocumentType from "./document-type";

import Cookies from "universal-cookie";

const cookies = new Cookies();

const Activity = ({ getSubModulesByRoleIdReducer, getSubModulesByRoleId }) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let documentTypeModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "3c3f0eb3-6899-4a21-8bec-cc950a9a4967",
  );

  let activityModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "bf05c3e4-c3df-48a0-8a45-4557b9309e39",
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {documentTypeModule && activityModule ? (
              <TabView>
                <TabPanel header="Document Type">
                  <DocumentType />
                </TabPanel>

                <TabPanel header="Activity Allocation">
                  <CreatedActivity />
                </TabPanel>
              </TabView>
            ) : !documentTypeModule && activityModule ? (
              <TabView>
                <TabPanel header="Activity Allocation">
                  <CreatedActivity />
                </TabPanel>
              </TabView>
            ) : documentTypeModule && !activityModule ? (
              <TabView>
                <TabPanel header="Document Type">
                  <DocumentType />
                </TabPanel>
              </TabView>
            ) : (
              <>
                <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                  No Activity Access
                </h4>
              </>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Activity);
